/**
 * @description Simple component for table cells that wrap the cell in a link so clicking on the cell can navigate to another page.
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import TableCell from '@mui/material/TableCell';
import Link from '@mui/material/Link';

const styles = {
  link: {
    display: 'block'
  }
};

/**
 * @prop children {string | number | element | element[]} - cell contents
 * @prop color {string} - color of the cell text (defaults to primary)
 * @prop href {string} - link of the cell
 * @prop sx {{ cell: object, link: object }} - css stylings for the cell and the link
 */
const LinkedCell = ({
  children,
  color,
  href,
  sx
}) => (
  <TableCell sx={sx?.cell}>
    <Link
      href={href}
      color={color}
      underline='none'
      sx={{ ...sx?.link, ...styles.link }}
    >
      {children}
    </Link>
  </TableCell>
);

LinkedCell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  color: PropTypes.string,
  href: PropTypes.string.isRequired,
  sx: PropTypes.shape({ cell: PropTypes.object, link: PropTypes.object })
};

LinkedCell.defaultProps = {
  color: 'text.primary',
  sx: null
};

export default LinkedCell;
